
import { useLocation } from "react-router-dom";
import { IdiomaSidebar } from "../common/sidebar/IdiomaSidebar";
import { DocenteSidebar } from "../common/sidebar/DocenteSidebar";
import { DocenteMenuSidebar } from "../common/sidebar/DocenteMenuSidebar";
import { ProgramaSidebar } from "../common/sidebar/ProgramaSidebar";
import { EstudianteSidebar } from "../common/sidebar/EstudianteSidebar";
import { EstudianteMenuSidebar } from "../common/sidebar/EstudianteMenuSidebar";
import { GrupoSidebar } from "../common/sidebar/GrupoSidebar";
import { PaisSidebar } from "../common/sidebar/PaisSidebar";
import { useSelector } from "react-redux";

export const Sidebar = () => {
  const location = useLocation();
  const rol = useSelector((store) => store.usuario.rol);

  const path = location.pathname;
  if (path.includes("programas")) {
    return <ProgramaSidebar />;
  }
  if ((path.startsWith("/idiomas") || path.includes("/modulos")) && (rol === "ADM" || rol === "SADM")) {
    return <IdiomaSidebar />;
  }
  if (path.includes("docentes") || path.includes("bitacora-asistencias")) {
    return <DocenteSidebar />;
  }

  if (
    (rol === "ADM" || rol === "SADM") &&
    (path.includes("estudiantes") ||
      path.includes("asignar-modulo") ||
      path.includes("registro"))
  ) {
    return <EstudianteSidebar />;
  }
  if (
    (rol === "ADM" || rol === "SADM") &&
    (path.includes("grupos") ||
      path.includes("turnos") ||
      path.includes("modalidades") ||
      path.includes("horarios"))
  ) {
    return <GrupoSidebar />;
  }
  if (
    (rol === "ADM" || rol === "SADM") &&
    (path.includes("/pais") || path.includes("/departamento") || path.includes("/provincia"))
  ) {
    return <PaisSidebar />;
  }
  
  // Sidebar para estudiantes (rol EST) - NO en perfil
  if (
    rol === "EST" &&
    (path.includes("inicio") ||
      path.includes("modulos") ||
      path.includes("historial-notas") ||
      path.includes("calendario-academico") ||
      path.includes("malla-curricular") ||
      path.includes("mis-logros")) &&
    !path.includes("perfilEstudiante") &&
    !path.includes("perfil/editar")
  ) {
    return <EstudianteMenuSidebar />;
  }
  
  // Sidebar para docentes (rol DOC) - NO en perfil
  if (
    rol === "DOC" &&
    (path.includes("inicio") ||
      path.includes("idiomas") ||
      path.includes("grupos") ||
      path.includes("asistencia") ||
      path.includes("calendario-academico") ||
      path.includes("malla-curricular") ||
      path.includes("docentes/plazo-notas") ||
      path.includes("docentes/descargar")) &&
    !path.includes("perfilDocente") &&
    !path.includes("editarPerfilDocente")
  ) {
    return <DocenteMenuSidebar />;
  }
  
  return <div></div>;
};
